<template>
  <div id="app" :class="i18nConfig.css">
    <router-view></router-view>
  </div>
</template>

<script>
import { i18nConfig } from '@/i18n';
export default {
  name: 'App',
  components: {},
  setup() {
    return {
      i18nConfig,
    }
  },
};
</script>

